import { REFRESHING_TOKEN_ERROR } from '../actions/refreshToken';
import { LOGINSTATE_LOGGED_IN_SUCCESS, 
    LOGINSTATE_RESETPASSWORD_SUCCESS,
    LOGINSTATE_RESETPASSWORD_ENTERED_SUCCESS,
    LOGINSTATE_RESETPASSWORD_ISFETCHING, 
    LOGINSTATE_RESETPASSWORD_ENTERED_ISFETCHING } from '../actions/login';

const DEFAULT_CUSTOMER_STATE =   {
    isFetching: false,
    email: 'nimi@helsinki.fi',
    lastName: '',
    firstName: '',
    ssnBic: '',
    tel: '',
    customerId: '',
    gender: '',
    password: '1',
    country: '1',
    language: 'Suomi',
    savedToCloud: false,
    termsAndUsage:true,
    isCompany:false };

const DEFAULT_LOGIN_STATE = {
    isFetching: false,
    loggedIn: false,
    userName: '',
    role: 0,
    passwordChangeRequested: false,
    passwordChangeEnteredRequested: false,
}



export function customerHasErrored(state = [], action) {  
    return state;
}
export function customerIsLoading(state = [], action) {
    return state;
}

export function loginState(state = DEFAULT_LOGIN_STATE, action) {
    switch (action.type) {
        case 'LOGINSTATE_LOGOUT' : {
            return {isFetching:false,username: '', loggedIn:false}
        }
        case REFRESHING_TOKEN_ERROR : {
            return {isFetching:false,username: '', loggedIn:false}
        }

        case LOGINSTATE_LOGGED_IN_SUCCESS: {
            return {isFetching:false,userName: action.loginData.username, loggedIn:true, role: action.loginData.role, customerId: action.loginData.customer.id}
        }          
        case LOGINSTATE_RESETPASSWORD_ISFETCHING: {
            return {isFetching:false, passwordChangeIsFetching:true}
        }          
        case LOGINSTATE_RESETPASSWORD_ENTERED_ISFETCHING: {
            return {isFetching:false, passwordChangeIsFetching:true}
        }          

        case LOGINSTATE_RESETPASSWORD_SUCCESS: {
            return {isFetching:false, passwordChangeIsFetching: false, passwordChangeRequested:true}
        }          
        case LOGINSTATE_RESETPASSWORD_ENTERED_SUCCESS: {
            return {isFetching:false, passwordChangeIsFetching:false, passwordChangeEnteredRequested:true}
        }          

        case 'LOGINSTATE_LOGGED_IN_FAILURE': {
            return {isFetching:false,username: '', loggedIn:false, loginResult: false}
        }          
        case 'LOGINSTATE_ISFETCHING': {
            return {isFetching: true, username: '', loggedIn:state.loggedIn}
        }

         
    
        default:
            return state;
    }
}


export function customer(state = DEFAULT_CUSTOMER_STATE, action) {
    switch (action.type) {
        case 'CUSTOMER_CREATE_SUCCESS': {        
            return action.customer;
        }
        case 'CUSTOMER_UPDATE_DATA':
        {
         
            var newstate = {
                ...state,                
                ...action.customer
                 }
            return Object.assign({}, state, newstate);
           }

        case 'CUSTOMER_ADDUPDATE_ID':
        {
            var updatedata = action;
            var newstate = {
                ...state,
                customerId: action.customerId
            }
            return newstate;
        }

        case 'CUSTOMER_HAS_ERRORED':
            return action.hasErrored;
      
        case 'CUSTOMER_IS_LOADING':
            return Object.assign({}, state, 
            {
                ...state, 
                isFetching: action.isFetching
            } );

        default:
            return state;
    }
}
